
import Header from "../models/header";
import UserForm from "@/components/users/UserForm.vue";
import Options from "@/models/options";
import * as profileAPI from "@/api/profile";
import {ProfileLogData, ProfileLog} from "@/api/profile";
import Profile from "@/shared/mixins/Profile";
import mixins from "vue-typed-mixins";
import ChangeRoleForm from "@/components/users/ChangeRoleForm.vue";

const MIXINS = [Profile];
const Vue = mixins(...MIXINS);

export default Vue.extend({
  name: "Users",
  components: {ChangeRoleForm},
  data() {
    return {
      loading: false as boolean,
      options: {} as Options,
      userForm: false as boolean,
      total: 0 as number,
      search: "" as string,
      profiles: [] as ProfileLog[],
      selectedUser: {
        role: 'user',
      } as ProfileLog,
      updatingLog: false as boolean
    };
  },
  watch: {
    options: {
      handler(): void {
        this.getUsers();
      },
      deep: true,
    },
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    getUsers() {
      this.loading = true;
      let limit = this.options.itemsPerPage;
      let skip =
          (this.options.page ? this.options.page - 1 : 0) *
          (this.options.itemsPerPage ?? 0);
      if (!limit || limit < 0) {
        limit = this.total;
      }
      profileAPI
          .getLogs(limit, skip, this.search)
          .then((logsData: ProfileLogData) => {
            this.total = logsData.total;
            this.profiles = logsData.data;
            this.loading = false;
          });
    },
    openChangeRole(profile: ProfileLog) {

      this.selectedUser = profile;
      const changeRoleForm: any = this.$refs.changeRoleForm;
      if (changeRoleForm) {
        changeRoleForm.openDialog(profile);
      }
    },
    getRole(profile: ProfileLog) {
      if(!profile) return this.$t("users.form.roles.user");
      switch (profile.role) {
        case 'admin':
          return this.$t("users.form.roles.admin");
        case 'maintainer':
          return this.$t("users.form.roles.maintainer");
        case 'user':
          return this.$t("users.form.roles.user");
        default:
          return this.$t("users.form.roles.user");
      }
    },
    updateProfiles(updatedProfile: ProfileLog) {
      this.profiles = this.profiles.map(elem => {
        if (elem.id == updatedProfile.id) {
          return updatedProfile;
        }
        return elem;
      })
    }
  },
  computed: {
    headers: {
      set() {
        return [];
      },
      get() {
        return [
          new Header(this.$t("users.headers.email"), "email"),
          new Header(this.$t("users.headers.name"), "name"),
          new Header(this.$t("users.headers.tenant"), "tenantName"),
          new Header(this.$t("users.headers.title"), "title"),
          new Header(this.$t("users.headers.role"), "role"),
          new Header(this.$t("users.headers.lastLogin"), "updatedAt"),
          new Header(this.$t("users.headers.actions"), "actions"),
        ];
      },
    },
  },
});
